<template>
  <div>
    <div
      class="search-wrapper"
      :class="{'dis':!searchful}"
    >
      <span>地区：</span>
      <!-- <Input style="width:80px;margin-right:10px;" type="text" v-model="searchValue.area"></Input> -->
      <Select
        v-model="searchValue.area"
        :style="{ width: multipleArea ? 'fit-content' : '120px', marginRight: '5px' }"
        @on-change="getArea"
        :multiple="multipleArea"
      >
        <Option
          v-for="depart in areaArr"
          :key="depart.id"
          :value="depart.name"
        >{{depart.name}}</Option>
      </Select>
      <span>分/子公司：</span>
      <Select
        v-model="searchValue.childcompany"
        style="width: 250px;margin-right:5px;"
      >
        <Option
          v-for="company in childCompanies"
          :key="company.id"
          :value="company.cName"
        >{{company.cName}}</Option>
      </Select>
      <span>项目简编：</span>
      <Input
        style="width:120px;margin-right:10px;"
        type="text"
        v-model="searchValue.projectNumAbbr"
      ></Input>
      <span>项目编号：</span>
      <Input
        style="width:180px;margin-right:10px;"
        type="text"
        v-model="searchValue.projectNum"
      ></Input>
      <span>项目名称：</span>
      <Input
        style="width:200px;margin-right:10px;"
        type="text"
        v-model="searchValue.projectName"
      ></Input>
      <!-- 其他搜索条件 -->
      <!-- 结项申请 -->
      <span v-if="extraSearch.searchEndTime">
        <span>审核状态：</span>
        <Select
          v-model="searchValue.endStatus"
          clearable
          style="width:150px;margin-right:5px;"
        >
          <!-- <Option :value="1">结项申请</Option>
          <Option :value="2">待复核</Option>
          <Option :value="3">初审不通过</Option>
          <Option :value="4">形式审核通过</Option>
          <Option :value="5">实质审核通过</Option>
          <Option :value="6">形式审核不通过</Option>
          <Option :value="7">实质审核不通过</Option> -->
          <Option :value="1">结项申请</Option>
          <Option :value="2">审核通过</Option>
          <Option :value="3">审核不通过</Option>
          <Option :value="4">形式审核通过</Option>
          <Option :value="6">形式审核不通过</Option>
        </Select>
        <span>结项申请时间：</span>
        <DatePicker
          type="daterange"
          placeholder="选择时间"
          style="width: 200px;margin-right:10px;"
          @on-change="selectTimeChange"
        ></DatePicker>
      </span>
      <span v-if="extraSearch.searchManager">
        <span>客户经理：</span>
        <Input
          v-model="searchValue.manager"
          style="width:100px;margin-right:10px;"
        ></Input>
        <span>项目助理：</span>
        <Input
          v-model="searchValue.assistant"
          style="width:100px;margin-right:10px;"
        ></Input>
        <span>跟进人员：</span>
        <Input
          v-model="searchValue.merchandiser"
          style="width:100px;margin-right:10px;"
        ></Input>
        <span>采购进出口：</span>
        <Select
          v-model="searchValue.import"
          style="width:80px;margin-right:5px;"
        >
          <Option value="是">是</Option>
          <Option value="否">否</Option>
        </Select>
      </span>
      <span v-if="extraSearch.moreSearch">
        <br>
        <span>开标时间：</span>
        <DatePicker
          type="daterange"
          placeholder="选择时间"
          style="width: 200px;margin-right:10px;"
          @on-change="selectMeetingTime"
        ></DatePicker>
      </span>
      <Button
        type="primary"
        @click="searchProject"
        style="margin:5px 0;"
      >搜索</Button>
      <Button
        type="primary"
        @click="viewReportForm"
        style="margin:5px;"
      >报表</Button>
      <slot name="extraBtn"></slot>
      <div
        v-if="extraSearch.searchModify"
        @click="show_detail"
        style="margin:5px 12px 5px 5px;display:inline-block;cursor:pointer;color:#2b85e4"
        class="ivu-menu-vertical ivu-menu-submenu"
        :class="{'ivu-menu-opened':detail_show}"
      >
        <span>更多筛选</span>
        <span>
          <i
            class="ivu-icon ivu-icon-ios-arrow-down ivu-menu-submenu-title-icon"
            style="top: 0px;cursor: pointer;font-size: 18px;margin-left:3px;"
          >
          </i>
        </span>
      </div>
    </div>
    <div v-if="detail_show">
      <!-- <span>预算金额(元)：</span>
      <Input v-model="searchValue.purchaseBudget" style="width:100px;margin: 5px 10px 5px 0;"></Input> -->
      <span>采购方式：</span>
      <Select
        v-model="searchValue.buyerModes"
        style="width: 160px;margin:5px 10px 5px 0;"
        class="state"
      >
        <Option
          v-for="company in cgway"
          :value="company.itemName"
        >{{company.itemName}}</Option>
      </Select>
      <span>招标平台：</span>
      <Select
        v-model="searchValue.bidPlatform"
        style="width: 160px;margin:5px 10px 5px 0;"
        class="state"
      >
        <Option
          v-for="company in bidplatform"
          :value="company.itemName"
        >{{company.itemName}}</Option>
      </Select>
      <span>行业系统：</span>
      <Input
        v-model="searchValue.clientSys"
        style="width:150px;margin: 5px 10px 5px 0;"
      ></Input>
      <span>项目状态：</span>
      <Select
        v-model="searchValue.projectState"
        style="width: 180px;margin:5px 10px 5px 0;"
        class="state"
      >
        <Option
          v-for="(state, index) in projectStates"
          :key="index"
          :value="state.itemName"
        >{{state.itemName}}</Option>
      </Select>
      <span>客户经理：</span>
      <Input
        v-model="searchValue.manager"
        style="width:100px;margin: 5px 10px 5px 0;"
      ></Input>
      <span>项目助理：</span>
      <Input
        v-model="searchValue.assistant"
        style="width:100px;margin-right:10px;"
      ></Input>
      <span>采购人：</span>
      <Input
        v-model="searchValue.purchaserName"
        style="width:110px;margin: 5px 10px 5px 0;"
      ></Input>
      <span>采购人属性：</span>
      <Input
        v-model="searchValue.purchaserType"
        style="width:110px;margin: 5px 10px 5px 0;"
      ></Input>
      <span>立项时间：</span>
      <DatePicker
        type="daterange"
        placeholder="选择时间"
        style="width: 200px;margin-right:10px;"
        @on-change="selectNewTime"
      ></DatePicker>
      <span>开标时间：</span>
      <DatePicker
        type="daterange"
        placeholder="选择时间"
        style="width: 200px;margin-right:10px;"
        @on-change="selectMeetingTime"
      ></DatePicker>
      <span>报名截止时间：</span>
      <DatePicker
        type="daterange"
        placeholder="选择时间"
        style="width: 200px;margin-right:10px;"
        @on-change="selectApplyEndTime"
      ></DatePicker>
      <span>项目性质：</span>
      <Input
        v-model="searchValue.projectProperty"
        style="width:100px;margin: 5px 10px 5px 0;"
      ></Input>
      <!-- <span>数据来源：</span>
      <Input v-model="searchValue.dataSource" style="width:100px;margin: 5px 10px 5px 0;"></Input> -->
    </div>
    <slot name="extraInfo"></slot>
    <Table
      :columns="projectColumns"
      :data="projectData"
      style="width:fit-content"
      @on-expand="expand"
    ></Table>
    <Page
      :total="pageTotal"
      :current="currentPage"
      show-elevator
      show-total
      style="margin-top:5px;"
      @on-change="pageChange"
    ></Page>
    <!-- 报表 -->
    <Modal title="结项审核报表" v-model="reportFormVisible" width="65%" height="95%" class-name="bidding-modal">
      <iframe :src="reportFormUrl" style="width:100%;height:100%;border:0;"></iframe>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import axios from 'axios'
import { formatDate } from '@/lib/tool'

export default {
  name: 'projectTable',
  props: {
    aheadColumns: {
      type: Array,
      default: () => {
        return []
      }
    },
    operateColumns: {
      type: Array,
      default: () => {
        return []
      }
    },
    extraQuery: {
      type: Object
    },
    extraSearch: {
      type: Object,
      default: () => {
        return {}
      }
    },
    searchful: {//是否显示搜索框
      type: Boolean,
      default: () => {
        return true
      }
    },
    multipleArea: { // 地区选择框是否多选
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      areaArr: [],
      childCompanies: [],
      projectStates: [],// 项目状态列表
      searchValue: {
        projectNum: '',
        projectName: '',
        area: '',
        projectNumAbbr: '',
        endStatus: '',
        manager: '',
        childcompany: '',
        assistant: '',
        merchandiser: '',
        //purchaseBudget: '',//预算金额
        buyerModes: '',//招标类型
        clientSys: '',//行业系统
        projectState: '',//项目状态
        purchaserType: '',  // 采购人属性
        purchaserName: '',//采购人
        newProjectTime: '',//立项时间
        projectProperty: '',//项目性质
        dataSource: '',//数据来源
        bidPlatform: '',//招标平台
        import: ''//采购进出口
      },
      columns: [
        {
          title: '分公司',
          key: 'district',
          width: 90
        },
        {
          title: '项目名称',
          key: 'projectName',
          minWidth: 250
        },
        {
          title: '项目编号',
          key: 'projectFull',
          width: 180
        },
        {
          title: '项目状态',
          key: 'projectState',
          width: 150
        },
        {
          title: '立项时间',
          width: 108,
          render: (h, params) => {
            if (params.row.newProjectTime) {
              return h('div', params.row.newProjectTime.split('T')[0])
              } else {
              return h('div', '')
            }
          }
        },
        {
          title: '开标时间',
          width: 108,
          render: (h, params) => {
            let time = '暂无'
            if (params.row.clMeetingRoom && params.row.clMeetingRoom.beginTime) {
              time = params.row.clMeetingRoom.beginTime.replace('T', ' ')
            }
            return h('div', time)
          }
        }
      ],
      currentPage: 1,
      pageTotal: 0,
      projectData: [],
      selectTime: [],
      detail_show: false,
      newTime: [],
      meetingTime: [],
      applyEndTime: [],
      cgway: [],// 采购方式
      bidplatform: [],// 招标平台
      reportFormUrl: '', // 报表地址
      reportFormVisible: false
    }
  },
  computed: {
    projectColumns() {
      return [...this.aheadColumns, ...this.columns, ...this.operateColumns]
    },
    user() {
      return this.$store.state.session.user
    }
  },
  async created() {
    this.getProjectData(1, {}, this.extraQuery)
    //获取采购方式列表
    this.cgway = await this.getDataDict('采购方式');
    //获取招标平台
    this.bidplatform = await this.getDataDict('招标平台')
    // 获取地区
    // let rep = await axios.get(
    //   this.baseUrl + "/CommonModule/Nprojecttable/Filiale"
    // )
    // this.areaArr = rep.data
    // this.areaArr.push({
    //   'ID': '0',
    //   '分公司': '全部'
    // })
    let rep = await ajax.get(requestUrls.CLDistrict.GetList)
    this.areaArr = []
    if (rep.data.success && rep.data.result.items.length > 0) {
      this.areaArr = rep.data.result.items
    }
    // 获取分子公司
    let childRep = await ajax.get(requestUrls.bankAccount.getAll)
    // this.childCompanies = childRep.data.result.items
    // 过滤重复数据
    let hadPush = []
    childRep.data.result.items.forEach(item => {
      if (hadPush.indexOf(item.cName) === -1) {
        hadPush.push(item.cName)
        this.childCompanies.push(item)
      }
    })
    this.childCompanies.push({
      id: 0,
      cName: '全部'
    })
    //获取项目状态
    let proRep = await ajax.get(requestUrls.AbpDataDict.getpage +
      `?filter=itemType%3D%3D%22%E9%A1%B9%E7%9B%AE%E7%8A%B6%E6%80%81%22&maxResultCount=100&skipCount=0`)
    this.projectStates = proRep.data.result.items
    this.projectStates.forEach((item, index) => {
      this.projectStates[index].id = index + 1
    });
    this.projectStates.push({
      id: 0,
      itemName: '全部'
    })
  },
  methods: {
    viewReportForm() {
      this.reportFormUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B7ed3%5D%5B9879%5D%5B5ba1%5D%5B6838%5D%2FFinalReview.cpt`
      this.reportFormVisible = true
    },
    // 权限控制由父级传入
    async getProjectData(page = 1, queryObj = {}, extraQuery = {}) {
      this.currentPage = page
      let querySear = ''
      let searNum = queryObj.projectNum ? ` and projectFull.Contains("${queryObj.projectNum}")` : ''
      let searName = queryObj.projectName ? ` and projectName.Contains("${queryObj.projectName}")` : ''
      // let searArea = (queryObj.area && queryObj.area !== '全部') ? ` and district.Contains("${queryObj.area}")` : ''
      let searArea = ''
      if (this.multipleArea) {
        if (queryObj.area && queryObj.area.length) {
          searArea += ' and (' 
          queryObj.area.forEach(a => {
            searArea += `district.Contains("${a}") or `
          })
          searArea = searArea.substring(0, searArea.length - 4)
          searArea += ')' 
        }
      } else {
        searArea = (queryObj.area && queryObj.area !== '全部') ? ` and district.Contains("${queryObj.area}")` : ''
      }
      // console.log(searArea)
      let searNumArr = queryObj.projectNumAbbr ? ` and projectShort.Contains("${queryObj.projectNumAbbr}")` : ''
      let searTime = this.selectTime.length > 0 ? ` and appStartTime >= "${formatDate(this.selectTime[0])}" and appStartTime <= "${formatDate(this.selectTime[1])}"` : ''
      let searEndStatus = queryObj.endStatus ? ` and endStatusCode == "${queryObj.endStatus}"` : ''
      let searManager = queryObj.manager ? ` and am.contains("${queryObj.manager}")` : ''
      let searAssistant = queryObj.assistant ? ` and aid.contains("${queryObj.assistant}")` : ''
      let searMerchandiser = queryObj.merchandiser ? ` and merchandiser.contains("${queryObj.merchandiser}")` : ''
      let searChildCompany = (queryObj.childcompany && queryObj.childcompany !== '全部') ? ` and companyName.contains("${queryObj.childcompany}")` : ''
      //展开查询
      //let searPurchaseBudget = queryObj.purchaseBudget ? ` and purchaseBudget.Contains("${queryObj.purchaseBudget}")` : ''
      let searBuyerModes = queryObj.buyerModes ? ` and buyerModes.Contains("${queryObj.buyerModes}")` : ''
      let searBidPlatform = queryObj.bidPlatform ? ` and bidPlatform.Contains("${queryObj.bidPlatform}")` : ''
      let searClientSys = queryObj.clientSys ? ` and clientSys.Contains("${queryObj.clientSys}")` : ''
      let searProjectState = (queryObj.projectState && queryObj.projectState != '全部') ? ` and projectState.Contains("${queryObj.projectState}")` : ''
      let searPurchaserName = queryObj.purchaserName ? ` and purchaserName.Contains("${queryObj.purchaserName}")` : ''
      let searPurchaserType = queryObj.purchaserType ? ` and pAttr.Contains("${queryObj.purchaserType}")` : ''
      let searNewProjectTime = this.newTime.length > 0 ? ` and newProjectTime >= "${formatDate(this.newTime[0])}" and newProjectTime <= "${formatDate(this.newTime[1])}"` : ''
      let searMeetingTime = this.meetingTime.length > 0 ? ` and clMeetingRoom.beginTime >= "${formatDate(this.meetingTime[0])}" and clMeetingRoom.beginTime <= "${formatDate(this.meetingTime[1])}"` : ''
      let searApplyEndTime = this.applyEndTime.length > 0 ? ` and applyEnd >= "${formatDate(this.applyEndTime[0])}" and applyEnd <= "${formatDate(this.applyEndTime[1])}"` : ''
      let searProjectProperty = queryObj.projectProperty ? ` and projectProperty.Contains("${queryObj.projectProperty}")` : ''
      let searDataSource = queryObj.dataSource ? ` and dataSource.Contains("${queryObj.dataSource}")` : ''
      let searImport = queryObj.import ? ` and import == "${queryObj.import}"` : ''

      let endStatus = extraQuery.endStatus ? extraQuery.endStatus : ''
      if (searEndStatus) {
        endStatus = ''
      }

      // 临时特殊设置
      let specialSetting = (extraQuery.endStatus && this.user.name === '何栩颖') ? ' and district != "广州"' : ''

      // 项目状态筛选
      let status = extraQuery.status ? extraQuery.status : ''
      // 开标过滤
      let bidTimeLimit = extraQuery.bidTimeLimit ? extraQuery.bidTimeLimit : ''
      // 角色权限筛选
      let rolePermission = extraQuery.rolePermission ? extraQuery.rolePermission : ''
      querySear = searNum + searName + searArea + searNumArr + rolePermission + status + searTime + searEndStatus + endStatus + searManager + searChildCompany + searAssistant + searMerchandiser
        + searBuyerModes + searClientSys + searProjectState + searPurchaserName + searPurchaserType + searNewProjectTime + searProjectProperty + searDataSource + searMeetingTime + searApplyEndTime + searBidPlatform + bidTimeLimit + specialSetting + searImport
      querySear = querySear.slice(5)
      let otherOrFilter = false
      if (extraQuery.specialPermission) {
        otherOrFilter = true
      }
      this.$Spin.show()
      let rep = await ajax.get(requestUrls.ClProjectDb.getPaged, {
        params: {
          flowLogReviewPerson: extraQuery.flowExmineFilter,
          needOtherFillter: otherOrFilter,
          filter: querySear,
          sorting: 'newProjectTime desc',
          maxResultCount: 10,
          skipCount: (page - 1) * 10
        }
      })
      if (rep.data.success) {
        this.projectData = rep.data.result.items
        this.pageTotal = rep.data.result.totalCount
        this.$store.commit('expertFeeCount', rep.data.result.totalCount)
        this.$emit('projectChange', this.projectData)
        this.$Spin.hide()
      }
    },
    searchProject() {
      this.currentPage = 1
      this.getProjectData(1, this.searchValue, this.extraQuery)
    },
    pageChange(page) {
      this.getProjectData(page, this.searchValue, this.extraQuery)
    },
    refreshProject() {
      this.getProjectData(this.currentPage, this.searchValue, this.extraQuery)
    },
    selectTimeChange(val) {
      this.selectTime = val
    },
    selectNewTime(val) {
      if (val[0] == '') {
        this.newTime = []
        return
      }

      this.newTime = val
    },
    selectMeetingTime(val) {
      if (val[0] == '') {
        this.meetingTime = []
        return
      }
      this.meetingTime = val
    },
    selectApplyEndTime(val) {
      if (val[0] == '') {
        this.applyEndTime = []
        return
      }
      this.applyEndTime = val
    },
    async getArea(district) {
      // console.log(district)
      let filter = ''
      if (this.multipleArea) {
        district.forEach(a => {
          filter += `district == ("${a}") or `
        })
        if (filter) filter = filter.substring(0, filter.length - 4)
      } else {
        filter = `district == "${district}"`
      }
      // console.log(filter)
      let rep = await ajax.get(requestUrls.bankAccount.getAll, {
        params: {
          filter
        }
      })
      this.searchValue.childcompany = ''
      this.childCompanies = rep.data.result.items
      // 去重
      let map = new Map()
      this.childCompanies = this.childCompanies.filter(item => !map.has(item.cName) && map.set(item.cName, 1))
    },
    expand(row, status) {
      this.$emit('on-expand', row, status)
    },
    show_detail() {//控制显示更多搜索
      this.detail_show = !this.detail_show
    },
    async getDataDict(type = '', ip = 0, id) {//ip控制是否只查询一级数据
      if (!type) {
        return []
      }
      let para = {}
      if (ip) {
        para = {
          filter: `itemType=="${type}"&&itemParent==""`
        }
      } else {
        para = {
          filter: `itemType=="${type}"`
        }
      }
      if (id) {
        para = {
          filter: `itemType=="${type}"&&itemParent=="${id}"`
        }
      }
      let rep = await ajax.get(requestUrls.AbpDataDict.GetList, {
        params: para
      })
      if (rep.data.success) {
        return rep.data.result.items
      }
      return []
    },
  },
  watch: {
    extraQuery(val) {
      if (val) {
        this.getProjectData(this.currentPage, this.searchValue, this.extraQuery)
      }
    }
  }
}
</script>

<style lang="less" >
.search-wrapper {
  margin: 0 0 10px 0;
}
.dis {
  display: none;
}
.state .ivu-select-dropdown {
  top: auto !important;
}
.bidding-modal {
  .ivu-modal {
    top: 20px;
    height: 95%;
    .ivu-modal-content {
      height: 100%;
    }
    .ivu-modal-body {
      height: 90%;
      overflow: hidden;
      padding: 0;
    }
  }
}
</style>
